import { IReferral } from "../../Services/Referral";

export function toEpochMs(value: unknown): number | null {
    if (value == null || value === "") {
        return null;
    }
    const numeric = Number(value);
    if (Number.isFinite(numeric) && numeric > 0) {
        return numeric < 1e12 ? numeric * 1000 : numeric;
    }
    const parsed = Date.parse(String(value));
    return Number.isNaN(parsed) ? null : parsed;
}

export function formatUsDate(value: unknown): string {
    const ms = toEpochMs(value);
    if (ms == null) {
        return "";
    }
    // Referral dates are calendar days stored at midnight UTC; a local zone west of UTC would show the previous day.
    return new Date(ms).toLocaleDateString("en-US", { timeZone: "UTC" });
}

export function formatReferralWhen(row: IReferral): string {
    if (row.isMultiYear) {
        const from = formatUsDate(row.fromDate);
        const to = formatUsDate(row.toDate);
        return from || to ? `${from}-${to}` : "";
    }
    return formatUsDate(row.referralDate);
}

export function shortFirmName(name: string | undefined): string {
    const text = (name ?? "").trim();
    if (text.length <= 20) {
        return text;
    }
    const cut = text.slice(0, 20);
    const space = cut.lastIndexOf(" ");
    return space > 1 ? cut.slice(0, space) : cut;
}

export function partyCell(name: string | undefined, firm: string | undefined): string {
    const person = (name ?? "").trim();
    const short = shortFirmName(firm);
    if (!person) {
        return short;
    }
    return `${person} / ${short}`;
}

export function memberPartyCell(name: string | undefined, firm: string | undefined): string {
    const person = (name ?? "").trim();
    return person ? `${person} / ${shortFirmName(firm)}` : `/ ${shortFirmName(firm)}`;
}

export function inputDate(value: unknown): string {
    const ms = toEpochMs(value);
    if (ms == null) {
        return "";
    }
    return new Date(ms).toISOString().slice(0, 10);
}

export function pageWindow(page: number, pageCount: number): Array<number | "…"> {
    if (pageCount <= 7) {
        return Array.from({ length: pageCount }, (_, index) => index + 1);
    }
    const numbers = new Set<number>([1, pageCount, page, page - 1, page + 1]);
    if (page <= 4) {
        numbers.add(2);
        numbers.add(3);
        numbers.add(4);
    }
    if (page >= pageCount - 3) {
        numbers.add(pageCount - 1);
        numbers.add(pageCount - 2);
        numbers.add(pageCount - 3);
    }
    const sorted = [...numbers].filter((number) => number >= 1 && number <= pageCount).sort((left, right) => left - right);
    const items: Array<number | "…"> = [];
    sorted.forEach((number, index) => {
        if (index > 0 && number - sorted[index - 1] > 1) {
            items.push("…");
        }
        items.push(number);
    });
    return items;
}

export function relationshipLabel(row: IReferral): string {
    return row.relationshipType === "collaboration" || row.relationshipType === "colaboration" ? "Collaboration" : "Referral";
}

export function apiErrorMessage(error: unknown, fallback: string): string {
    const response = (error as { response?: { data?: { message?: string } } })?.response;
    return response?.data?.message || fallback;
}
